import { useEffect, useSyncExternalStore } from 'react'
import { loadLanguage, subscribeWords, wordsVersion } from './catalog'

/** Re-renders when a language file arrives or the organisation's words change; fetches lang's file. */
export function useWords(lang: string): number {
  useEffect(() => {
    void loadLanguage(lang)
  }, [lang])
  return useSyncExternalStore(subscribeWords, wordsVersion, wordsVersion)
}
